import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./invoice.css";
import commaNumber from "comma-number";
let format = commaNumber.bindWith(",", ".");
const InvoiceBody = ({
  saleData,
  detailsOverride,
  startIndex = 0,
  hideCountry = false,
  showCountryPrintToggle = false,
  hideCountryInPrint = false,
  onHideCountryInPrintChange,
}) => {
  const classes = useStyles();
  // Invoice body

  /// end

  // console.log(sale)
  let [sale, saleSet] = useState([]);
  let [saleDetails, saleDetailsSet] = useState([]);

  useEffect(() => {
    saleSet(saleData || {});

    if (detailsOverride !== undefined) {
      saleDetailsSet(detailsOverride);
    } else if (saleData && saleData.details !== undefined) {
      saleDetailsSet(saleData.details);
    }
  }, [saleData, detailsOverride]);

  return (
    <>
      <table className={"invoice-table"}>
        <thead>
          <tr>
            <th style={{ textAlign: "left" }}>SL</th>
            <th style={{ textAlign: "left" }}>Category</th>

            <th style={{ textAlign: "left" }}>Description</th>
            <th>Brand</th>
            {!hideCountry ? (
              <th>
                <span>Country</span>
                {showCountryPrintToggle ? (
                  <label
                    className="invoice-print-toggle no-print"
                    title="Tick to hide Country column while printing"
                  >
                    <input
                      type="checkbox"
                      checked={hideCountryInPrint}
                      onChange={(event) =>
                        onHideCountryInPrintChange &&
                        onHideCountryInPrintChange(event.target.checked)
                      }
                    />
                    <span>Hide</span>
                  </label>
                ) : null}
              </th>
            ) : null}
            <th>Qty</th>
            <th>Rate</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {saleDetails.map((detail, ind) => (
            <tr key={ind}>
              <td style={{ textAlign: "left" }}>{startIndex + ind + 1}</td>
              <td style={{ textAlign: "left" }}>{detail.prod_cat_name}</td>
              <td style={{ textAlign: "left" }}>{detail.prod_name}</td>
              <td>{detail.prod_brand_name}</td>
              {!hideCountry ? <td>{detail.prod_color_name}</td> : null}
              <td>
                {detail.sale_qty} {detail.prod_unit_name}
              </td>
              <td>{format(parseFloat(detail.sale_rate || 0).toFixed(2))} </td>
              <td style={{ textAlign: "right" }}>
                {format(parseFloat(detail.sale_prod_total || 0).toFixed(2))}
              </td>
            </tr>
          ))}

          {/* <tr>
            <td style={{ textAlign: "right" }}></td>
            <td style={{ textAlign: "right" }}></td>
            <td>
              {saleDetails
                .reduce((prev, curr) => {
                  return prev + parseFloat(curr.sale_qty);
                }, 0)
                .toFixed(2)}{" "}
            </td>
            <td></td>
            <td style={{ textAlign: "right" }}></td>
          </tr> */}
        </tbody>
      </table>
    </>
  );
};

const useStyles = makeStyles((theme) => ({}));

export default InvoiceBody;
